import React, { Component } from 'react';
import { Navbar, NavbarToggler } from 'reactstrap';

class Header extends Component {
  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }
  render() {
    return (
      <div style={{ ...this.props.styles }}>
        <Navbar color="faded" light>
          <NavbarToggler onClick={this.props.handleOnClick} />
        </Navbar>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/views/Components/Header.js